import { SpinnerContainer, SpinnerOverlay } from './spinner.style';

const Spinner = () => (
    <SpinnerOverlay>
        <SpinnerContainer />
    </SpinnerOverlay>
);

export default Spinner;